<template>
  <van-popup
    v-model="myVisible"
    position="bottom"
    safe-area-inset-bottom
    @close="hidePopup"
  >
    <van-nav-bar title="查看溯源" @click-right="hidePopup">
      <template #right>
        <van-icon name="close" size="20" />
      </template>
    </van-nav-bar>
    <div v-if="myVisible" class="popup-content">
      <div class="product-info">
        <unit-title title="基本信息" />
        <div>名称：{{ traceTempData.materialName }}</div>
        <div v-if="traceCode">
          产品标准：{{ traceData.productPlantStandard ||'普通' }}农产品
        </div>
        <div>供应商：{{ traceTempData.supplier||'暂无供应商' }}</div>
      </div>
      <!--  有溯源信息    -->
      <template v-if="traceCode">
        <farm-land-data :user-id="userId" class="content-item module" :trace-data="traceData" />
        <farm-work-record-steps class="content-item module" :farm-work-records="traceData.farmWorkJSON" />
      </template>
    </div>
  </van-popup>
</template>

<script>
import { popup } from '@/utils/mixins/popup'
import { traceDataByTraceCode } from '@/utils/mixins/traceDataByTraceCode'
import FarmLandData from '@/views/productManage/TraceSource/components/FarmLandData'
import FarmWorkRecordSteps from '@/views/productManage/TraceSource/components/FarmWorkRecordSteps'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
export default {
  name: 'ProductInfoPopup',
  components: { UnitTitle, FarmWorkRecordSteps, FarmLandData },
  mixins: [popup, traceDataByTraceCode],
  props: {
    traceCode: {
      type: String,
      default: undefined
    },
    traceTempData: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      traceData: {
        farmWorkJSON: [],
        land: {},
        userId: undefined
      }
    }
  },
  computed: {
    userId() {
      return this.traceData.userId
    },
    landId() {
      if (this.traceData.landId) {
        return this.traceData.landId
      }
      return undefined
    }
  }
}
</script>

<style lang='less' scoped>
.van-nav-bar {
  position: sticky;
  top: 0;
}
.popup-content{
  //height: calc(80vh - 46px);
  //overflow-y: auto;
  padding: 12px;
}
.product-info {
  font-size: 14px;
  color: #333;
}
</style>
